import React, { useState, useEffect } from "react"

import { Content } from "./payment_form/content"
import { Loading } from "./payment_form/loading"

import { useFetch } from "hooks/use-new-fetch"
import { usePromoCode } from "hooks/use-promo-code"

export function PaymentForm({
  billingCycle = "year",
  plans,
  serviceLevel,
  handleSubscription,
  onPlanChange,
  modalOptions,
  options
}) {
  const [data, setData] = useState(null)
  const [request, loading] = useFetch("/onboarding/payment_form")

  const { promoCode, promoCodeLoaded } = usePromoCode()

  // Built by hand rather than through queryParams, which runs every entry
  // through URLSearchParams.set and would serialize an absent service level as
  // the string "undefined".
  const query = () => {
    const params = new URLSearchParams({ promo_code: promoCode })
    if (serviceLevel) params.set("service_level", serviceLevel)
    return params.toString()
  }

  const fetchData = async () => {
    const response = await request.get({ path: `?${query()}` })
    setData(response.data)
  }

  useEffect(() => {
    if (!promoCodeLoaded) return

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promoCode, promoCodeLoaded, serviceLevel])

  return (
    <>
      {!data && loading && <Loading />}

      {!!data && !loading && (
        <Content
          handleSubscription={handleSubscription}
          onPlanChange={onPlanChange}
          billingCycle={billingCycle}
          stripeData={data.stripe_data}
          currentPlans={plans || data.current_plans}
          trialPeriodEnd={data.trial_period_end}
          trialing={data.trialing}
          currentlyOnFreePlan={data.free_plan}
          modalOptions={modalOptions}
          options={options}
        />
      )}
    </>
  )
}
